// Seuils responsive partagés web + mobile, alignés sur Tailwind. Volontairement
// limité : on n'expose que les paliers réellement utilisés (cf. useAppBreakpoint).
export const BREAKPOINTS = { sm: 640, md: 768, lg: 1024, xl: 1280 } as const;

export type BreakpointName = keyof typeof BREAKPOINTS;
